import { Box } from '@mui/material'
import { useLogin } from '@refinedev/core'
import { useNavigate } from 'react-router'
import { useForm } from 'react-hook-form'
import { LoginHeader, LoginForm } from './components'

type TLoginFormData = {
  email: string
  password: string
}

export const Login = () => {
  const navigate = useNavigate()
  const { mutate: login, isLoading } = useLogin()

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<TLoginFormData>({
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = (data: TLoginFormData) => {
    login({ username: data.email, password: data.password, redirectTo: '/request' })
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.paper', position: 'relative' }}>
      <LoginHeader />
      <LoginForm
        control={control}
        errors={errors}
        isValid={isValid}
        isLoading={isLoading}
        onForgotPasswordClick={() => navigate('/forgot-password')}
        onSubmit={handleSubmit(onSubmit)}
      />
    </Box>
  )
}
